import { render, staticRenderFns } from "./FollowupApproval.vue?vue&type=template&id=ceca10fc&scoped=true"
import script from "./FollowupApproval.vue?vue&type=script&lang=js"
export * from "./FollowupApproval.vue?vue&type=script&lang=js"
import style0 from "./FollowupApproval.vue?vue&type=style&index=0&id=ceca10fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceca10fc",
  null
  
)

export default component.exports